export default "__VITE_ASSET__CMDN61$y__"